import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import projects from "./projects.module";
import vars from "./vars.module";
import directory from "./directory.module";
import notifications from "./notifications.module";
import calendar from "./calendar.module";
import expertise from "./expertises.module";
import methodics from "./methodics.module";
import experts from "./experts.module";
import ealist from "./ealist.module";
import grouporgs from "./grouporgs.module";
import monitoringlizingorgs from "./monitoringlizingorgs.module";
import requests from "./requests.module";
import admin from "./admin.module";
import conference from "./conference.module";
import submitted from "./submitted.module";
import project from "./project.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    projects,
    vars,
    directory,
    notifications,
    calendar,
    expertise,
    methodics,
    experts,
    ealist,
    grouporgs,
    monitoringlizingorgs,
    requests,
    admin,
    conference,
    submitted,
    project
  }
});
